/**
 * Created by JackCui on 2021/1/11
 */

import {parsing, rulesHandle} from './parsing'
import eventsBind from './eventsBind'
import {rulesValuesRelation, objectRulesValues} from './submitRulesValues'
import {ruleModelHandle} from './utils/data-handle'

/**
 * 初始化规则 绑定事件 执行一次规则更新当前页面状态
 * @param formKey this中存放数据的key
 * @param pageDriven 页面配置
 * @param varMap
 * @param dispatch
 */
export default function init (
  {
    formKey = 'formData',
    pageDriven,
    varMap,
    dispatch
  }
) {
  if (!pageDriven.length) {
    return
  }
  // 为每个相关组件绑定事件
  eventsBind.call(this, {
    formKey,
    eventHandle: rulesHandle({
      pageDriven,
      varMap,
      dispatch
    })
  })

  // 初始化结束先跑规则 让页面状态和规则一致
  rulesHandle({
    pageDriven,
    varMap,
    dispatch
  })()
}

/**
 * 规则处理
 * 1.事件绑定
 * 2.规则解析
 * 3.事件驱动
 */
export {
  eventsBind,
  parsing,
  rulesHandle,
  ruleModelHandle,
  rulesValuesRelation,
  objectRulesValues
}
